/**
 * @vuepress
 * ---
 * title: Permissions
 * ---
 */

import { mapGetters } from 'vuex'
import store from '@/store'

const permissionsMixin = {
  computed: {
    ...mapGetters('account', {
      '$modelPermission': 'modelPermission',
      '$modelUserPermission': 'modelUserPermission',
      '$can': 'userCan',
      '$canAdd': 'userCanAdd',
      '$canChange': 'userCanChange',
      '$canView': 'userCanView',
      '$canDelete': 'userCanDelete',
      '$isAdmin': 'userIsAdmin',
      '$inGroup': 'userInGroup'
    }),
    $isProvider() {
      return this.$inGroup('Proveedor')
    }
  },
  methods: {
    $isClient(...clients) {
      const client = store.getters['account/client']
      if (client) {
        if (clients.length) {
          const mappedClients = clients.map((c) => c.toLowerCase())
          return mappedClients.includes(client) ? client.toUpperCase() : false
        }
        return client.toUpperCase()
      }
      return false
    },
    $isFileOwner({ uploadedBy = 0 }) {
      const restrictedGroups = ['AuxCompras', 'DesProveedores', 'Proveedor']
      const userId = store.getters['account/userId']
      return !restrictedGroups.some((g) => this.$inGroup(g)) || +userId === +uploadedBy
    }
  }
}

const commentNode = (el, vnode, hide = true) => {
  console.log('hidding node')
  el.style.display = hide ? 'none' : 'block'
}

const permissionsDirective = (checkHasPermission = true, separator = '\\') =>
  (el, bindings, vnode) => {
    const { arg: permission, modifiers: appsModels } = bindings
    Object.entries(appsModels).forEach(([appModel]) => {
      const [app, model] = appModel.split(separator)

      console.assert(!!app && !!model, `wrongly specified app\\model "${appModel}"`)
      const hasPermission = store.getters['account/userCan'](
        permission, app, model
      )

      if (checkHasPermission ? !hasPermission : hasPermission) {
        commentNode(el, vnode)
      }
    })
  }

export default {
  install(Vue) {
    Vue.mixin(permissionsMixin)
    Vue.directive('can', permissionsDirective(true))
    Vue.directive('cant', permissionsDirective(false))
  }
}
